// import { useParams } from 'next/navigation';
import { SVGProps } from 'react';

const ProfileVector = (props: SVGProps<SVGSVGElement>) => {
  // const { section } = useParams<{ section?: string }>();
  // const sectionValue = section?.toLowerCase();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 24 24"
      fill="none"
      // stroke={sectionValue === 'woman' || !sectionValue ? '#fff' : '#000'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5136 14.8719C3.6694 16.3 2.1514 18.0103 1.41787 19.1262C1.26619 19.357 0.956167 19.4211 0.725413 19.2694C0.494659 19.1177 0.430558 18.8077 0.582239 18.5769C1.38248 17.3595 2.97908 15.5698 4.90133 14.0812C6.81143 12.6021 9.13107 11.3516 11.3704 11.3516C11.6466 11.3516 11.8704 11.5754 11.8704 11.8516C11.8704 12.1277 11.5 11.9997 11.5 11.9997C9.59818 11.9997 7.36995 13.4344 5.5136 14.8719Z"
        fill="#C08190"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2298 12.7565C15.0953 12.9977 15.1817 13.3022 15.4229 13.4367C18.2496 15.0136 19.5635 16.7503 21.1072 19.2619C21.2517 19.4972 21.5597 19.5707 21.7949 19.4261C22.0302 19.2815 22.1037 18.9735 21.9591 18.7383C20.3739 16.159 18.95 14.2593 15.9101 12.5634C15.6689 12.4289 15.3643 12.5153 15.2298 12.7565Z"
        fill="#C08190"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6662 11.1212C14.3656 11.1212 16.5921 8.87681 16.5921 6.06061C16.5921 3.24441 14.3656 1 11.6662 1C8.96671 1 6.74023 3.24441 6.74023 6.06061C6.74023 8.87681 8.96671 11.1212 11.6662 11.1212ZM11.6662 12.1212C14.939 12.1212 17.5921 9.40779 17.5921 6.06061C17.5921 2.71343 14.939 0 11.6662 0C8.39336 0 5.74023 2.71343 5.74023 6.06061C5.74023 9.40779 8.39336 12.1212 11.6662 12.1212Z"
        fill="#C08190"
      />
    </svg>
  );
};

export default ProfileVector;
